import type { PriorityLevel } from '../../../../types'
import { PRIORITY_COLORS, PRIORITY_BG_COLORS } from '../../../../constants/colors'

interface PriorityBadgeProps {
  priority: PriorityLevel
  size?: 'sm' | 'md'
}

const priorityLabels: Record<PriorityLevel, string> = {
  HIGH: 'High Priority',
  MEDIUM: 'Medium',
  LOW: 'Low',
}

export default function PriorityBadge({ priority, size = 'sm' }: PriorityBadgeProps) {
  const sizeClasses = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-sm'

  return (
    <span
      className={`inline-flex items-center font-medium rounded-full ${sizeClasses}`}
      style={{
        backgroundColor: PRIORITY_BG_COLORS[priority],
        color: PRIORITY_COLORS[priority],
      }}
    >
      {priorityLabels[priority]}
    </span>
  )
}
